import { render, staticRenderFns } from "./DeliverySettingsComponent.vue?vue&type=template&id=415f2b70&"
import script from "./DeliverySettingsComponent.vue?vue&type=script&lang=js&"
export * from "./DeliverySettingsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports